import React, { useEffect} from "react";
import "./Footer.css";
import { FaFacebook, FaYoutube } from "react-icons/fa6";
import { FaInstagramSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkedAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";


function Footer() {


    
    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

  
   

    return (
        <footer className="footer bg_footer py-5 ">
            <div className="container-fluid" style={{ overflow: 'hidden' }}>

                <div className="row gy-4">
                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div style={{ background: '#a20000', borderRadius: '20px',width:'180px' }} className="p-2">
                            <Link to="/" className="footer-logo" onClick={handleClick}>
                                {/* <img src='/Round Corner Logo0 (1).png' alt="logo" className="img-fluid" style={{ width: '200px' }} width={200} height={200} loading="lazy" /> */}
                                <img className="logo-image p-1"
                                    src="/Round Corner Logo0 (1).png"
                                    srcSet="/Round Corner Logo0 (1).png 150w, /Round Corner Logo0 (1).png 300w"
                                    style={{width:'150px'}}
                                    width="150" height="51"
                                    alt="logo"
                                    />

                            </Link>
                        </div>

                        <div className="social_icons mt-3 d-flex gap-3 flex-wrap">
                            <a href="https://www.facebook.com/gautamsolarprivatelimited" aria-label="Facebook" className="icon"><FaFacebook /></a>
                            <a href="https://www.instagram.com/gautam_solar/" aria-label="Instagram" className="icon"><FaInstagramSquare /></a>
                            <a href="https://www.linkedin.com/company/gautam-solar-group/" aria-label="Linkedin" className="icon"><FaLinkedin /></a>
                            <a href="https://www.youtube.com/@GautamSolarOfficial" aria-label="Youtube" className="icon"><FaYoutube /></a>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="footer-item">
                            <h4 className="text-black">Company</h4>
                        </div>
                        <ul className="footer-list">
                            <li><Link to="/" onClick={handleClick}>Home</Link></li>
                            <li><Link to="/aboutus" onClick={handleClick}>About Us</Link></li>
                            <li><Link to="#" onClick={handleClick}>Solar Modules</Link></li>
                            <li>
                                <ul className="elementor-icon-list-items ps-3">
                                    <li><a href="/topcon" onClick={handleClick}>— N-type TOPCon Modules</a></li>
                                    <li><a href="/mono" onClick={handleClick}>— Mono PERC Modules</a></li>
                                </ul>
                            </li>
                            <li><Link to="/solarplants" onClick={handleClick}>Solar Power Plants</Link></li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="footer-item">
                            <h4 className="text-black">Quick Links</h4>
                        </div>
                        <ul className="footer-list">
                            {/* <li><Link to="/rei" onClick={handleClick}>REI 2025</Link></li> */}
                            <li><Link to="/blog" onClick={handleClick}>Blogs</Link></li>
                            <li><Link to="/terms" onClick={handleClick}>Terms & Conditions</Link></li>
                            <li><Link to="/policy" onClick={handleClick}>Privacy Policy</Link></li>
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-6 col-sm-12">
                        <div className="footer-item">
                            <h4 className="text-black">Contact</h4>
                        </div>
                        <div className="footer-list">
                            <a href="https://maps.app.goo.gl/DhV4nVN86Henkkxv7" className="footer-address">
                                <FontAwesomeIcon icon={faMapMarkedAlt} /> D-120-121, Okhla Industrial Area, Phase-1, New Delhi-110020
                            </a>
                            <a href="tel:+919311797248" className="footer-contact">
                                <FontAwesomeIcon icon={faPhone} /> +91 93117 97248
                            </a>
                            <a href="mailto:info@gautamsolar.com" className="footer-contact">
                                <FontAwesomeIcon icon={faEnvelope} /> info@gautamsolar.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;






